import ENetsIdeationLayout from './enets_ideation_layout.jsx'

const ENetsIdeationPage = () => {
  return (
      <ENetsIdeationLayout />
  );
};

export default ENetsIdeationPage;